/*=========================================================================================
File Name: themeConfig.js
Description: Theme configuration
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
Author: Pixinvent
Author URL: hhttp://www.themeforest.net/user/pixinvent
==========================================================================================*/

// MAIN COLORS - VUESAX THEME COLORS
let colors = {
	primary: '#0142F8',
	success: '#29813A',
	danger: '#FA2627',
	warning: '#FCB414',
	dark: '#2A2E34',
	info: '#2184BC',
}

// CONFIGS
const themeConfig = {
	disableCustomizer : false,       // options[Boolean] : true, false(default)
	disableThemeTour  : true,       // options[Boolean] : true, false(default)
	footerType        : "static",    // options[String]  : static(default) / sticky / hidden
	hideScrollToTop   : false,       // options[Boolean] : true, false(default)
	mainLayoutType    : "vertical",  // options[String]  : vertical(default) / horizontal
	navbarColor       : "#fff",      // options[String]  : HEX color / rgb / rgba / Valid HTML Color name - (default: #fff)
	navbarType        : "sticky",  // options[String]  : floating(default) / static / sticky / hidden
	routerTransition  : "fade",      // options[String]  : zoom-fade / slide-fade / fade-bottom / fade / zoom-out / none(default)
	rtl               : false,       // options[Boolean] : true, false(default)
	sidebarCollapsed  : true,       // options[Boolean] : true, false(default)
	theme             : "light",     // options[String]  : "light"(default), "dark", "semi-dark"
	
	// Not required yet - WIP
	userInfoLocalStorageKey: "userInfo",
	
	// NOTE: themeTour will be disabled in screens < 1200. Please refer docs for more info.
}

import Vue from 'vue';
import Vuesax from 'vuesax';
Vue.use(Vuesax, { theme:{ colors }, rtl: themeConfig.rtl });

export default themeConfig;